<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="closeinfo" :rules="rules" ref="closerule" label-width="120px" class="">
			<el-row>
				<el-col :span="22">
					<el-form-item label="订单编号" prop="orderno">
						<el-input clearable v-model="closeinfo.orderno" :disabled="true"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22">
					<el-form-item label="备注" prop="reason">
						<el-input clearable v-model="closeinfo.reason" maxlength="200"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button plain @click="closeDlg">取消</el-button>
			<el-button type="primary" @click="saveCloseOrderInfo">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { closeOrder } from '/static/apiUrl.js'
	export default {
		name : 'OrderClose',
		data() {
			return {
				editok : false,
				closeinfo : {
					"userpwd": "",
					"orderno": "",
					"reason": "",
				},			
				rules: {
					reason : [
						{ required: true, message: '请输入备注', trigger: 'blur' }
					],
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			orderno : {
				type: String,
				required: false
			},
		},
		watch: {
			orderno: {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
					this.clearData()
					this.closeinfo.orderno = newVal;
				}
			},
		},
		methods: {
			clearData(){
				this.closeinfo = {
					"userpwd": "",
					"orderno": "",
					"reason": "",
				}
				this.editok = false
			},
			closeDlg() {
				this.$emit("needRefrash",false,false)
			},
			saveCloseOrderInfo() {
				this.$refs["closerule"].validate((valid) => {			
					if (valid) {
						this.$prompt('请输入您的密码', '提示', {
							inputType: 'password',
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(({ value }) => {
							this.closeinfo.userpwd = this.$md5(value)
							closeOrder(this.closeinfo).then(res => {
									console.log(res)
									if(0 == res.code){
										//this.editok = true
										this.clearData()
										this.$emit("needRefrash",true,false)
										this.$message.success("关闭订单成功")
									}else{
										this.$emit("needRefrash",false,true)
										this.$message.error(res.msg)
									}
								})
						}).catch(() => { });
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>